module.exports = __webpack_public_path__ + "static/media/21ECLAC2.707319c5.jpg";